import React from 'react';
import { Copy, CheckCircle2 } from 'lucide-react';

export interface QuickPaymentsProps {
  className?: string;
  blikPhone?: string; // raw digits e.g. 664821160
  blikDisplay?: string; // formatted e.g. 664-821-160
  paypalEmail?: string;
  columns?: 'one' | 'two';
}

export function QuickPayments({
  className = '',
  blikPhone = '664821160',
  blikDisplay = '664-821-160',
  paypalEmail = 'przytulisko.jb@o2.pl',
  columns = 'two'
}: QuickPaymentsProps) {
  const [copiedField, setCopiedField] = React.useState<string | null>(null);

  const copyToClipboard = (text: string, field: string) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopiedField(field);
      setTimeout(() => setCopiedField(null), 2000);
    });
  };

  return (
    <div className={`grid ${columns === 'one' ? 'grid-cols-1' : 'grid-cols-1 md:grid-cols-2'} gap-8 ${className}`}>
      {/* BLIK */}
      <div className="relative bg-gradient-to-br from-white via-white to-accessible-red-600/5 dark:from-accessible-gray-800 dark:via-accessible-gray-800 dark:to-accessible-red-600/10 high-contrast:bg-black high-contrast:from-black high-contrast:via-black high-contrast:to-black p-8 rounded-lg shadow-xl border-2 border-accessible-red-600/20 dark:border-accessible-red-600/30 overflow-hidden">
        {/* Czerwony akcent na górze */}
        <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-accessible-red-600 to-accessible-red-700 high-contrast:bg-white high-contrast:from-white high-contrast:to-white"></div>
        
        <div className="flex items-center justify-between mb-6">
          <h2 className="heading-3 no-margin text-accessible-gray-900 dark:text-white">BLIK</h2>
          <img
            src="/images/payments/BLIK/blik.svg"
            alt="Logo BLIK"
            className="h-6 md:h-7 w-auto"
            loading="lazy"
          />
        </div>

        <div className="bg-white dark:bg-accessible-gray-700 high-contrast:bg-black p-6 rounded-lg mb-4 shadow-sm border border-accessible-red-600/10">
          <div className="flex items-center justify-between">
            <div>
              <p className="label-medium mb-1 text-accessible-gray-900 dark:text-white high-contrast:text-white">Numer telefonu</p>
              <p className="heading-4 font-mono text-accessible-gray-900 dark:text-white">{blikDisplay}</p>
            </div>
            <button
              onClick={() => copyToClipboard(blikPhone, 'blik')}
              className="p-2 hover:bg-accessible-red-600/10 dark:hover:bg-accessible-red-600/20 rounded-lg transition-colors"
              title="Skopiuj numer BLIK"
              aria-label="Skopiuj numer BLIK"
            >
              {copiedField === 'blik' ? (
                <CheckCircle2 className="w-5 h-5 text-green-600" />
              ) : (
                <Copy className="w-5 h-5 dark:text-white high-contrast:text-white" />
              )}
            </button>
          </div>
        </div>
        <p className="body-small text-accessible-gray-600 dark:text-accessible-gray-300 high-contrast:text-white no-margin">
          Otwórz aplikację banku → BLIK → Przelew na telefon → wklej numer i zatwierdź.
        </p>
      </div>

      {/* PayPal */}
      <div className="bg-white dark:bg-accessible-gray-800 high-contrast:bg-black p-8 rounded-lg shadow-lg">
        <div className="flex items-center justify-between mb-6">
          <h2 className="heading-3 no-margin">PayPal</h2>
          <img
            src="/images/payments/paypal/paypal.svg"
            alt="Logo PayPal"
            className="h-6 md:h-7 w-auto"
            loading="lazy"
          />
        </div>

        <div className="bg-accessible-gray-50 dark:bg-accessible-gray-700 high-contrast:bg-black p-6 rounded-lg mb-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="label-medium mb-1 dark:text-white high-contrast:text-white">Adres email</p>
              <p className="heading-5 font-mono">{paypalEmail}</p>
            </div>
            <button
              onClick={() => copyToClipboard(paypalEmail, 'paypal')}
              className="p-2 hover:bg-accessible-red-600/10 dark:hover:bg-accessible-red-600/20 rounded-lg transition-colors"
              title="Skopiuj adres PayPal"
              aria-label="Skopiuj adres PayPal"
            >
              {copiedField === 'paypal' ? (
                <CheckCircle2 className="w-5 h-5 text-green-600" />
              ) : (
                <Copy className="w-5 h-5 dark:text-white high-contrast:text-white" />
              )}
            </button>
          </div>
        </div>
        <p className="body-small text-accessible-gray-600 dark:text-accessible-gray-300 high-contrast:text-white no-margin">
          Wygodne płatności online, także z zagranicy.
        </p>
      </div>
    </div>
  );
}

export default QuickPayments;


